import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Chip,
  Grid2,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TokenAccordionSummary from "../Deployments/TokenAccordionSummary";
import TokenAccordionDetails from "../Deployments/TokenAccordionDetails";
import { chipColorStyles, stringToColor } from "../../support/utils";

const KeywordTag = ({ alert }) => {
  const theme = useTheme();
  const tagColor = stringToColor(alert.paramString1, theme);
  return (
    <Grid2 size={12} justifyItems={"center"}>
      <Chip
        size="small"
        sx={{ ...chipColorStyles(theme, tagColor) }}
        label={`${alert.paramString1}`}
        variant="outlined"
      />
    </Grid2>
  );
};

const KeywordsAccordion = ({ alert, filters }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      disableGutters={true}
      square={true}
      elevation={5}
      expanded={expanded}
      slotProps={{ transition: { timeout: 200 } }}
    >
      <AccordionSummary
        sx={{ pointerEvents: "none" }}
        expandIcon={
          <Button
            sx={{
              pointerEvents: "auto",
              display: { xs: "contents", sm: "inline-flex" },
            }}
            onClick={() => setExpanded((prev) => !prev)}
          >
            <ExpandMoreIcon />
          </Button>
        }
      >
        <TokenAccordionSummary
          token={alert.token}
          filters={filters}
          tag={<KeywordTag alert={alert} />}
        />
      </AccordionSummary>
      <AccordionDetails sx={{ display: "inline-block", width: "100%" }}>
        <TokenAccordionDetails token={alert.token} open={expanded} />
      </AccordionDetails>
    </Accordion>
  );
};

export default KeywordsAccordion;
